/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/prefer-default-export */
import React from "react";

import type { MergedOption } from "../../services/util/optionRendering";

import ClassicGroupPicker from "./components/ClassicGroupPickerV2";
import OptionPicker from "./components/OptionPicker";
import RichGroupPicker from "./components/RichGroupPickerV2";

export interface ProductOptionPickerProps
  extends Omit<MergedOption, "isCanonical" | "type"> {
  /** the currently selected value */
  selectedValue: string;

  /** component classes */
  className?: string;

  /** event handler for when selected value changes */
  onChange: (name: string, value: string) => unknown;

  /** whether the group is nested (for visual treatment) */
  isNested?: boolean | null;

  type?: MergedOption["type"] | "graphic-square";

  /** whether the option picker is being used in a modal */
  inModal?: boolean;
}

/**
 * Renders the appropriate tiles component given product options
 */
export function ProductOptionPicker(props: ProductOptionPickerProps) {
  const { groups, appearance } = props;

  if (groups) {
    return appearance !== "rich" ? (
      <ClassicGroupPicker {...props} groups={groups} />
    ) : (
      <RichGroupPicker {...props} groups={groups} />
    );
  }

  return <OptionPicker {...props} />;
}
